import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { html, LitElement, type CSSResultGroup } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { style } from './skeleton.style.js'
import { classMap } from 'lit/directives/class-map.js'

export const skeletonVariants = ['primary', 'secondary'] as const
export type skeletonVariantTypes = typeof skeletonVariants

@customElement('cse-skeleton')
export class CSESkeleton extends LitElement {

  static override styles: CSSResultGroup = [hostStyle, style]

  @property({ type: String })
  variant: skeletonVariantTypes[number] = 'primary'

  @property({ type: Number })
  height: number | null = null

  @property({ type: Number })
  width: number | null = null

  @property({ type: Number })
  index: number = 0

  private formatSize(sizeValue: number | null) {
    if(!sizeValue || isNaN(sizeValue)) {
      return 'auto'
    }

    return `${sizeValue}px`
  }

  override render() {
    return html`<div class="${classMap({
      'cse-skeleton': true,
      [`variant-${this.variant}`]: true,
    })}"
    style="
      height: ${this.formatSize(this.height)};
      width: ${this.formatSize(this.width)};
      --delay: ${this.index * 100}ms;
    "
    ></div>`
  }
}
